const FileManagementApi = {
    photoUpload: '/file/photo/upload',
    photoRemove: '/file/photo/remove',
    photoRemoveAll: '/file/photo/remove-all',
    photoEditorUpload: '/file/photo/editor-upload',
}

export default FileManagementApi;
